module.exports = __webpack_public_path__ + "static/img/logoColor.7adab37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integrations/primavera/logoColor.svg
// module id = 3261
// module chunks = 0